import { Form, Formik } from "formik";
import style from "./WithdrawFunds.module.scss";
import * as Yup from 'yup';
import { Button, Input } from "@ui";
import { useWithdrawMoneyMutation } from "@RTKQuery/user/referrals/referrals";

export function WithdrawFunds() {
    const [withdrawMoney, { isLoading, isSuccess, error, reset }] = useWithdrawMoneyMutation();

    return (
        <div className={style.container}>
            <p className={style.label}>Вивести кошти</p>
            <Formik
                initialValues={{
                    amount: '',
                }}
                validationSchema={Yup.object({
                    amount: Yup.number().required("Сума - обов'язкове поле").min(5, "Мінімальна сума для поповнення 5$")
                })}
                onSubmit={(values, actions) => {
                    withdrawMoney({
                        amount: Number(values.amount)
                    })
                        .unwrap()
                        .then(() => {
                            actions.resetForm()
                        })
                        .catch(() => { })
                }}
            >
                {props => (
                    <Form>
                        <div className="flex gap-[15px] items-start max-sm:flex-col max-sm:w-full">
                            <Input
                                label="Сума"
                                type="text"
                                onChange={(newValue) => {
                                    props.setFieldValue("amount", newValue.replace(/\D/g, "").trim())
                                }}
                                onBlur={props.handleBlur}
                                value={props.values.amount}
                                name="amount"
                                customStyle={{
                                    width: style.customInput
                                }}
                                error={props.touched.amount ? props.errors.amount : ""}
                            />
                        </div>
                        <Button
                            type="submit"
                            text="Вивести на баланс"
                            color="blue"
                            form="ellipse"
                            customStyle={{
                                button: "!px-[45px] !min-w-[220px] !h-[40px] max-sm:!mx-auto"
                            }}
                            loading={isLoading}
                            successContent={
                                isSuccess
                                    ? {
                                        title: "Вітаємо!",
                                        description: <p className="max-w-[260px]"><span className="font-bold">Ви успішно вивели кошти.</span></p>
                                    }
                                    : undefined
                            }
                            errors={[
                                (error && ((extractError) => {
                                    const err = extractError(error)

                                    return err
                                }))
                            ]}
                            resetStatus={() => {
                                reset();
                            }}
                        />
                    </Form>
                )}
            </Formik>
        </div>
    )
}